(ns app.front.view.complaint.complaints-section
  (:require [app.domain.group.config.model :as config-model]
            [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.ui.table :as ui-table]
            [app.front.view.complaint.detail-view :as complaint-detail-view]
            [app.front.view.complaint.subs :as complaint-subs]
            [app.front.view.workspace.section :as ws-section]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub ::complaint-items
  (fn [_ _]
    [(rf/subscribe [::ws-subs/complaints])
     (rf/subscribe [:language])
     (rf/subscribe [::ws-subs/tr])])
  (fn [[complaints lang tr] _]
    (->> complaints
         (map (fn [complaint]
                (let [id                      (:db/id complaint)
                      complaint-id            (:complaint/id complaint)
                      tz                      (-> complaint :domain/authority-group :group/tz)
                      date                    (date-util/date-in-tz (:entity/created complaint) tz)
                      category                (-> complaint
                                                  :complaint/category-group-config
                                                  (config-model/localized-name lang))
                      description             (:complaint/description complaint)
                      severity                (tr [(:complaint/severity complaint) ""])
                      description-of-location (:complaint/description-of-location complaint)
                      state                   (tr [(:domain/state complaint)])]
                  (util/mmap id date category description description-of-location state complaint-id severity)))))))


(defn modal-button [tr complaint-id]
  (cc/button {:on-click #(>evt [::complaint-subs/show-complaint-modal complaint-id])
              :size     :small
              :kind     :ghost}
             (tr [:complaint/view-complaint])))


(defn remove-button [tr target id]
  [:div.flex.justify-end
   [ui/modal-confirmation-button
    {:id                  (str id "-remove-complaint-button")
     :tr                  tr
     :modal-title         (tr [:complaint/remove-confirmation])
     :trigger-button-opts {:kind             :ghost
                           :size             :small
                           :icon-position    :right
                           :icon             i/remove
                           :icon-description (tr [:complaint/remove-from-case])
                           :class-name       "only-icon-button"}
     :trigger-button-text ""
     :on-yes-click        #(>evt [::process/signal
                                  target
                                  [:process.signal/remove-complaint-from-case
                                   {:complaint-id id}]
                                  {:notify {:success :complaint/removed}}])}
    (tr [:complaint/remove-explanation])]])


(defn complaint-table [tr items case-view?]
  (let [lang           (<sub [:language])
        show-severity? (<sub [::ws-subs/show-complaint-severity?])
        target         (<sub [::ws-subs/execution])
        can-remove?    (<sub [::process/signal-permitted? target [:process.signal/remove-complaint-from-case]])]
    [:<>
     [ui-table/modern-responsive-table
      {:items   items
       :cols    [[:complaint/state :state {:width "100px"}]
                 [:complaint/date :date {:width "150px"}]
                 [:complaint/category :category {:width     "150px"
                                                 :truncate? true}]
                 (when show-severity?
                   [:complaint/severity :severity {:width "100px"}])
                 [:complaint/description :description {:truncate? true}]
                 [:complaint/description-of-location :description-of-location {:truncate? true}]
                 [""
                  (fn [{:keys [complaint-id]}]
                    [modal-button tr complaint-id])
                  {:width "175px"}]
                 (when (and case-view? can-remove?)
                   [""
                    (fn [{:keys [id]}]
                      [remove-button tr target id])
                    {:max-width "50px"}])]
       :tr      tr
       :id-func :id}]
     [complaint-detail-view/complaint-modal-view (util/mmap {:allow-edit? false} tr lang)]]))


(defn section []
  (let [tr     (<sub [::ws-subs/tr])
        target (<sub [::ws-subs/execution])
        items  (<sub [::complaint-items])]
    (when (not-empty items)
      [ws-section/section target :complaint/case-title {:tr tr} :complaint/case-title false
       [complaint-table tr items true]])))
